import fetcher from '../../modules/ajio-fetch';
import { fetchGetJSONReqOpts } from '../../modules/ajio-fetch/utils';
import properties from '../../modules/ajio-util/properties';
import HeaderCache from '../../utils/cacheViaHeader';

const url = properties.getProperty('apiUrl');
const rilwebserviceUrl = '/rilfnlwebservices/v2/rilfnl';

const fetchFunction = (endPoint, token, headerInfo = {}) => {
  return fetcher(
    endPoint,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...headerInfo
      },
      credentials: 'include'
    })
  );
};
const referralApiEndPoint = `${url}${rilwebserviceUrl}/referral/referralConfigs`;
const cache = new HeaderCache(fetchFunction, () => {
  return referralApiEndPoint;
});
export const getReferralConfigApi = (token, headerInfo = {}) => {
  return cache.getData(referralApiEndPoint, token, headerInfo);
};

export const isReferralCachedData = () => {
  return cache.isCachedData(referralApiEndPoint)?.value;
};
